export default "__VITE_ASSET__DNDnmWKp__"